
module dg.lists {

    class SearchPatternController {

        //public query: domain.queries.ListQuery<dg.domain.IDomainObject>;

        public get query() {
            return this.queryManipulator.query;
        }

        private queryManipulator: dg.actions.ServerQueryManipulator;

        public filter = () => {
            this.queryManipulator.executeQuery();
        }

        $onInit = () => {
            //this.query = this.queryManipulator.query;
        }
    }

    angular.module('dg.lists').component('searchPattern', {
        bindings: {
            queryManipulator: '<'
        },
        controller: SearchPatternController,
        templateUrl: '/digmo/src/lists/search-pattern.html'
    });
}